import * as React from "react";
import { MainContent } from "../../MainContent";
import { ToggleOddsBtnType } from "../../../components";
import { CardType, MarketTemplate } from "../../../../../data";

export class RenderMainHeading extends React.PureComponent<{
    id: string,
    name: string,
    subName?: string
    eventsCountLength: number,
    cms: any,
    filterProps?: any,
    dict: any
    shouldCollapse: boolean
    toggleOddsBtn?: ToggleOddsBtnType
    marketNames: Array<Array<string>>
    marketTemplates: MarketTemplate[]
    cardType: CardType
}, {}> {

    render() {
        const name = `${this.props.cms.ShowLivePhraseBeforeSportName ? this.props.dict.Live : ""} ${this.props.name} ${this.props.subName || ""}`;
        const eventsCount = this.props.cms.ShowSportEventsCount ? `(${this.props.eventsCountLength})` : "";

        const props = {...this.props, ...{name, eventsCount}}
        return (
            <MainContent key={`sport-content-${this.props.id}`} {...props}>
                {this.props.children}
            </MainContent>
        )
    }

}